import React from "react";

interface Props {
  shown: number;
  total: number;
  last: boolean;
  loading?: boolean;
  onClick: () => void;
}

const LoadMoreButton: React.FC<Props> = ({ shown, total, last, loading, onClick }) => {
  if (last) return null;

  return (
    <div className="flex flex-col items-center gap-1 mt-4">
      <button
        type="button"
        onClick={onClick}
        disabled={loading}
        className="py-2 px-5 text-sm font-medium text-green-700 border border-green-600 rounded-lg hover:bg-green-50 disabled:opacity-50"
      >
        {loading ? "Loading..." : "Load more"}
      </button>
      <span className="text-xs text-gray-500">
        Showing {shown} of {total}
      </span>
    </div>
  );
};

export default LoadMoreButton;
